@if (createdDate) {
  <div class="text-muted small">
    @if (createdBy) {
      <span>Created by {{ createdBy }} on </span>
    }
    @if (!createdBy) {
      <span>Created on </span>
    }
    {{ createdDate | date:'MM-dd-yyyy' }} at {{ createdDate | date:'h:mm a' }}
  </div>
}
